import React, { useMemo } from "react"
import { withMicrocopy } from "~contexts/MicrocopyContext"
import { FiInfo } from "react-icons/fi"
import Dropdown from "../../SampleCodeCatalog/Dropdown/Dropdown.component"
import { compareVersions, VERSION_INFO } from '../../../utils/versioning'
import * as style from "./VersionDropdown.module.scss"

const VersionDropdown = ({
  microcopy, version, versions, onSelectVersion, addon = false,
}) => {
  const getInfoOptionContent = () => (
    <div>
      <FiInfo className={style.infoIcon} />
      <span>{microcopy.text("versions.about")}</span>
    </div>
  )

  const versionOptions = useMemo(
    () => versions
      .sort(compareVersions) // sort versions in descending order
      .map((v) => ({ value: v, label: v }))
      .concat(addon ? [{
        value: VERSION_INFO,
        content: getInfoOptionContent(),
      }] : []),
    [versions],
  )

  return (
    <Dropdown
      selectedValuePrefixText={microcopy.text("versions.label")}
      dropdownType="minimal"
      options={versionOptions}
      readOnly={versionOptions?.length < 2}
      onChange={(option) => onSelectVersion(option.value)}
      selectedValue={versionOptions.find((v) => v.value === version)}
      customMenuClass={style.dropdownMenu}
    />
  )
}
export default withMicrocopy(VersionDropdown)
